import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      component: () => import('./components/LoginPage')
    },
    {
      path: '/index',
      component: () => import('./components/ArticleNav'),
      meta: { requiresAuth: true },
      children: [
        {
          path: 'create',
          component: () => import('./components/CreateArticle')
        },
        {
          path: 'detail',
          component: () => import('./components/ArticleDetail')
        },
        {
          path: 'list',
          component: () => import('./components/ArticleList')
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!sessionStorage.token) {
      next('/login')
    } else {
      next()
    }
  } else {
    next()
  }
});

export default router
